/**
 * PageFooter
 */
import React from 'react';
import { Grid, Cell } from 'ui-component-library/base';
import { uhmLogo } from 'ui-component-library/assets';
export var FooterHeader = function (_a) {
    var children = _a.children;
    return (React.createElement("h2", { className: "text-p font-bold" }, children));
};
export var FooterTop = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "py-6 border-t-2 border-b-2 border-greySemiLight bg-greyLight" }, children));
};
export var FooterMiddle = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "pt-6 bg-greyLight" }, children));
};
export var FooterText = function (_a) {
    var children = _a.children;
    return (React.createElement("p", { className: "mb-6 lg:mb-4 text-p" }, children));
};
export var FooterDescList = function (_a) {
    var children = _a.children;
    return (React.createElement("dl", { className: "text-p footer__dl mb-6 lg:mb-4" }, children));
};
export var FooterLinkList = function (_a) {
    var children = _a.children;
    return (React.createElement("ul", { className: "text-p footer__linklist footer__dl mb-6 lg:mb-4" }, children));
};
export var ContentWrapper = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "items-center justify-between pt-2 md:flex" }, children));
};
export var BottomContent = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "-ml-2 lg:ml-0" }, children));
};
/** Main description for this component. */
var PageFooter = function (_a) {
    var logoLink = _a.logoLink, className = _a.className, children = _a.children;
    return (React.createElement("footer", { "data-cid": "PageFooter", className: className },
        React.createElement("div", { className: "py-6 border-t-2 border-b-2 border-greySemiLight bg-greyLight" },
            React.createElement(Grid, { padding: false, className: "px-4 lg:px-6" },
                React.createElement(Cell, { span: 12 }, logoLink ? (React.createElement("a", { href: logoLink },
                    React.createElement("img", { src: uhmLogo, alt: "", className: "footer-logo", height: "61", width: "169" }))) : (React.createElement("img", { src: uhmLogo, alt: "", className: "footer-logo", height: "61", width: "169" }))))),
        React.createElement("div", { className: "pt-6 bg-greyLight" }, children)));
};
export default PageFooter;
